import { motion } from 'framer-motion'
import { StyleContentWrapper } from '@pages/front/commons/ContentWrapper/style'
import {
  StyleDownloadAppBannerWrapper,
  StyleImage,
  StyleImageWrapper,
  StyleRightContentWrapper,
} from './style'
import DocAndPatientImage from './DocAndPatient.png'
import { StyleText } from '@pages/front/commons/Text/style'
import { StyleDownloadButtonsWrapper } from '../BannerSlider/style'
import { AppleStoreSvg, GooglePlayStoreSvg } from '@pages/front/svgs/svg'

const MotionBannerWrapper = motion(StyleDownloadAppBannerWrapper)
const MotionImageWrapper = motion(StyleImageWrapper)
const MotionText = motion(StyleText)
const MotionButtonWrapper = motion(StyleDownloadButtonsWrapper)

const DownloadAppBanner = () => {
  return (
    <StyleContentWrapper>
      <MotionBannerWrapper
        whileInView={{ opacity: 1, y: 0 }}
        initial={{ opacity: 0, y: 30 }}
        transition={{ duration: 0.5 }}
        viewport={{ once: true, amount: 0.3 }}
      >
        <MotionImageWrapper
          whileInView={{ opacity: 1, x: 0 }}
          initial={{ opacity: 0, x: -30 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true, amount: 0.3 }}
        >
          <StyleImage src={DocAndPatientImage} />
        </MotionImageWrapper>

        <StyleRightContentWrapper>
          <MotionText
            color="#262f77"
            fontSize="35"
            centered
            fontSizeSm="1.2"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true, amount: 0.3 }}
          >
            Download The Supchar App
          </MotionText>
          <MotionText
            textWidth="500"
            centered
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            viewport={{ once: true, amount: 0.3 }}
          >
            Access Video Consultation with Supchar, Connect with top doctors
            24/7 from the comfort of your home.
          </MotionText>

          <MotionButtonWrapper
            marginTop="35"
            direction="row"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            viewport={{ once: true, amount: 0.3 }}
          >
            <div dangerouslySetInnerHTML={{ __html: GooglePlayStoreSvg }} />
            <div dangerouslySetInnerHTML={{ __html: AppleStoreSvg }} />
          </MotionButtonWrapper>
        </StyleRightContentWrapper>
      </MotionBannerWrapper>
    </StyleContentWrapper>
  )
}

export default DownloadAppBanner
